/**
 * HTTP layer for user profile bits. Avatar upload/removal and the groups a user
 * is eligible to join.
 *
 * Contains:
 * - uploadUserAvatar / deleteUserAvatar: avatar writes
 * - fetchEligibleUserGroups: groups a user may be assigned
 */
import apiClient from '@sophocles/http-common';

const USER_ENDPOINT = '/users';

// Avatar upload/clear ride on the dedicated user avatar action. Upload
// (POST multipart `file`) routes the image through create_binary_file as
// a customuser/profile-photo BinaryFile; clear (DELETE) removes the
// stored profile photo. No FK — the serializers resolve the avatar URL
// from the BinaryFile polymorphically.
export const uploadUserAvatar = (userId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return apiClient
    .post(`${USER_ENDPOINT}/${userId}/avatar/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(res => res.data);
};

export const deleteUserAvatar = userId => apiClient.delete(`${USER_ENDPOINT}/${userId}/avatar/`).then(res => res.data);

export const fetchEligibleUserGroups = userId =>
  apiClient.get(`${USER_ENDPOINT}/${userId}/eligibleusergroups/`, { params: { limit: 10000 } }).then(res => res.data);
